/*
 * @Author: your name
 * @Date: 2021-06-18 16:17:00
 * @LastEditTime: 2021-10-12 14:49:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\cameraList\api\index.js
 */
export const api = {
  deviceMan: {
    getDeviceTypeListByPage: '/bms/device/getDeviceTypeListByPage.json', // 查询设备类型
    getDeviceInfoDetailsById: '/bms/device/getDeviceInfoDetailsById.json', // 查询设备详情
    getDeviceListByPage: '/bms/device/getDeviceListByPage.json', // 查询设备列表
    updateDeviceInfoById: '/bms/device/updateDeviceInfoById.json', // 修改设备信息
    getFactoryListByPage: '/bms/device/getFactoryListByPage.json', // 查询厂商
    //queryAssociationalDeviceTree: '/cms/account/queryAssociationalDeviceTree.json', // 查询区域树
    queryAssociationalDeviceTree: '/cms/area/queryAreaByAccountName.json', // 查询区域树
    deleteDeviceInfoById: '/bms/device/deleteDeviceInfoById.json', // 删除设备
    updateDeviceArea: '/bms/device/updateDeviceArea.json', // 设备挪入挪出
    updateCameraFeature: 'bms/device/updateCameraFeature.json', // 设备批量修改虚拟属性
    queryDeviceTypeCount: 'bms/device/queryDeviceTypeCount.json', // 设备批量修改虚拟属性
    getDeviceExportList: '/bms/device/getDeviceExportList.json', //导出文件
    deviceImportList: '/bms/device/deviceImportList.json', //导入文件
  },
  queryDeviceWorkGroup: '/bms/device/queryDeviceWorkGroup.json', //查询设备组树 2021.1.26
  addDeviceWorkGroup: '/bms/device/addDeviceWorkGroup.json',
  updateDeviceWorkGroup: '/bms/device/updateDeviceWorkGroup.json',
  deleteDeviceWorkGroup: '/bms/device/deleteDeviceWorkGroup.json',
  updateDeviceDeviceWorkGroup: '/bms/device/updateDeviceDeviceWorkGroup.json', //挪入挪出设备组信息
  downloadFile: '/bms/device/exportFireDeviceList.json', //导出消防设备信息

  // 迭代五 消防列表
  queryFirefightOperationList: '/bas/firefightoperation/queryFirefightingOperationList.json', //查询运行数据列表
  addBuilding: '/cms/building/addBuilding.json', //新增楼栋/楼层信息
  updateBuilding: '/cms/building/updateBuilding.json', //修改楼栋/楼层信息
  deleteBuilding: '/cms/building/deleteBuilding.json', //删除楼栋/楼层信息
  queryBuildingTree: '/cms/building/queryBuildingTree.json', //查询楼栋/楼层树
  batchFileload: '/common/file/batchFileload.json', // 上传图片
  // queryFireDeviceStatus: 'cms/accessportal/queryFireDeviceStatus.json', // 查询消防主机状态更新
  queryDeviceStatus: 'cms/accessportal/queryDeviceStatus.json', // 查询消防主机状态更新
  queryFireDeviceList: 'bms/device/queryFireDeviceList.json ', // 查询设备列表
  queryFirefightingCameraList: '/bms/device/queryFirefightingCameraList.json ', // 查询视频配置信息
  updateFirefightingCamera: '/bms/device/updateFirefightingCamera.json', // 修改视频配置信息
  queryDeviceWorkGroupDeviceTree: '/bms/device/queryDeviceWorkGroupDeviceTree.json', //查询消防设备组设备树
  queryDeviceWorkGroupDeviceTreeNew: '/bms/device/queryDeviceWorkGroupDeviceTreeLimit.json', //查询消防设备组设备树New
  queryDeviceWorkGroupDeviceTreeMore: '/bms/device/queryDeviceWorkGroupDeviceTreeOffset.json', //查询消防设备组设备树More
  updateDeviceBuilding: '/cms/building/updateDeviceBuilding.json', //保存设备图纸位置
  getDeviceDetail: "/bms/device/queryDeviceDetails.json",//查询设备信息,
  getCanvasList: "/cms/building/queryDeviceListByBuilding.json",//查询打点设备信息,
  config: {
    queryConfigList: '/bms/device/queryFireFightingOperationConfigListApi.json',
    addConfigStep: '/bms/device/addFireFightingOperationConfigApi.json',//新增步骤
    updateConfigStep: '/bms/device/updateFireFightingOperationConfigApi.json',//修改步骤
    deleteConfigStep: '/bms/device/deleteFireFightingOperationConfigApi.json', //删除步骤
  },
  fireTruck: {
    queryFireTruckDeviceList: '/bms/device/queryFireTruckDeviceList.json', //查询消防车接口
  },
  querySosList: "/cms/accessportal/querySosDeviceList.json",//获取一键求救列表
  updateSosDevice: '/cms/accessportal/updateSosDevice.json', //update一键求救设备
  //查询电气火灾列表:
  electricDevice: {
    queryElectricalFireDeviceList: "/bms/device/queryElectricalFireDeviceList.json", //查询设备维护的列表
    updateElectricalFireDevice: "/bms/device/updateElectricalFireDevice.json",  //修改设备维护的列表
    exportElectricalFireDeviceList: "/bms/device/exportElectricalFireDeviceList.json",  //导出电气火灾列表接口
    queryElectricalFireAlarmInfo: "/bms/device/queryElectricalFireAlarmInfo.json",  //查询电气火灾告警信
  },
  // 设备操作类型配置
  queryConfigTypeList: "/bms/device/queryFireFightingOperationConfigTypeList.json",//获取操作类型列表
  addConfigTypeList: "/bms/device/addFireFightingOperationConfigType.json",//新增操作类型列表
  deleteConfigTypeList: "/bms/device/deleteFireFightingOperationConfigType.json",//删除操作类型列表
  updateConfigTypeList: "/bms/device/updateFireFightingOperationConfigType.json",//修改操作类型列表
}